<template>
  <div class="otp-modal">
    <div class="modal__back" @click="$emit('back')">
      <svgo-arrow-left width="20" height="20" class="icon" />
    </div>
    <div class="otp-modal__inner">
      <h2 class="otp-modal__title" v-html="$t('modal.login.otp_title')" />
      <p
        class="otp-modal__subtitle"
        v-html="$t('modal.login.otp_subtitle', { email })"
      />
    </div>

    <div class="otp-modal__form">
      <v-otp-input
        ref="otpInput"
        :num-inputs="4"
        input-type="number"
        inputmode="numeric"
        :should-auto-focus="true"
        :should-focus-order="true"
        class="otp-modal__container"
        :input-classes="['otp-modal__input', { _error: error }]"
        @on-complete="$emit('send-otp', $event)"
      />
      <p
        v-if="error"
        ref="error"
        class="otp-modal__error-text"
        :style="{
          'max-height': `${errorHeight}px`,
          'padding-top': errorHeight ? '8px' : 0,
        }"
        v-html="$t(error)"
      />
      <div class="otp-modal__send-again">
        <template v-if="timeout">
          {{ $t('modal.login.send_again_in', { timeout: formatTime }) }}
        </template>
        <span v-else class="btn" @click="$emit('submit-email-otp', email)">
          {{ $t('modal.login.send_again') }}
        </span>
      </div>
    </div>

    <div class="otp-modal__terms">
      <p>
        {{ $t('modal.continuing_registration_agree_text') }}
        <a
          href="https://imast.am/terms"
          target="_blank"
          class="link"
          v-html="$t('modal.terms')"
        />
        {{ $t('and') }}&nbsp;
        <a
          href="https://imast.am/privacy"
          target="_blank"
          class="link"
          v-html="$t('modal.policy')"
        />
      </p>
    </div>
  </div>
</template>

<script setup>
import VOtpInput from 'vue3-otp-input';

defineEmits(['send-otp', 'back', 'submit-email-otp']);

const { email, timeout } = defineProps({
  email: {
    type: String,
    required: true,
  },
  timeout: {
    type: Number,
    default: null,
  },
  referrer: {
    type: String,
    default: null,
  },
  error: {
    type: String,
    default: null,
  },
});

const otpInputRef = useTemplateRef('otpInput');
const errorRef = useTemplateRef('error');

const errorHeight = computed(() => {
  return errorRef?.value?.scrollHeight + 8 || 0;
});

const formatTime = computed(() => {
  if (!timeout) return '';
  const minutes = Math.floor(timeout / 60);
  const remainingSeconds = timeout % 60;

  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
});

onMounted(() => {
  const inputsList = otpInputRef.value.$el.querySelectorAll('input');
  inputsList.forEach((input) => {
    input.setAttribute('autocomplete', 'one-time-code');
  });
});
</script>

<style lang="scss">
@use '@/assets/styles/components/modal/otp-modal.scss' as *;
</style>
